import {
  DeleteFolderDocument,
  DeleteFolderMutation,
  DocumentsFolderItemFragment,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteFolderDocument = (folder: DocumentsFolderItemFragment, companyId: string) => {
  const [deleteFolderMutation, { loading }] = useMutation(DeleteFolderDocument, {
    extractorFn: (data: DeleteFolderMutation) => data.documentsMutations.destroyDocumentsFolder,
  })

  return {
    loading,
    deleteFolder() {
      return deleteFolderMutation({
        variables: { id: folder.id, companyId: companyId },
        update(cache) {
          cache.evict({ id: cache.identify(folder) })
        },
      })
    },
  }
}
